import { render } from "./person-vehicle-update.vue?vue&type=template&id=80fc423c"
import script from "./person-vehicle-update.vue?vue&type=script&lang=js"
export * from "./person-vehicle-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__